@import '~style-sheet-helpers/core.less';
@import '../order-summary-shared.module.less';

.order-summary {
  width: 100%;
}

.in-drawer {
  padding: 15px;
}

.order-summary-container {
  &:extend(.order-summary-container);
}

.section-title {
  @order-summary-and-customer-recipient-title-text();
}

.summary-section {
  &:extend(.summary-section);
  flex: 1;
}

.section-with-edit-button {
  flex-direction: row;
  align-items: flex-start;

  .edit-button {
    flex: 1;
    @od-action-buttons-font-size();
  }
}

@media (max-width: 1024px) {
  .order-summary-container {
    flex-direction: row;
    min-width: 196px;
    padding-right: 4px;
  }
}
